import { useApiClient } from '@chilipiper/api-client/src/context'
import {
  OwnershipRoutingRequest,
  TeamSchedulingApiClientV1,
} from '@chilipiper/api-client/src/team-scheduling'
import { queryOptions, skipToken, useQuery } from '@tanstack/react-query'

interface RouteGuestToOwnershipSchedulingLinkParams {
  tenantId?: string
  ownershipSchedulingLinkId?: string
  data?: OwnershipRoutingRequest
}

const routeGuestToOwnershipSchedulingLinkQuery = ({
  tenantId,
  teamScheduling,
  ownershipSchedulingLinkId,
  data,
}: RouteGuestToOwnershipSchedulingLinkParams & {
  teamScheduling: TeamSchedulingApiClientV1
}) =>
  queryOptions({
    queryKey: [
      tenantId,
      ownershipSchedulingLinkId,
      'team-scheduling/route-guest-to-ownership-scheduling-link',
    ],
    queryFn:
      tenantId && ownershipSchedulingLinkId && data
        ? () =>
            teamScheduling.routeGuestToAOwnershipSchedulingLink(
              tenantId,
              ownershipSchedulingLinkId,
              data
            )
        : skipToken,
    retry: false,
  })

export const useRouteGuestToOwnershipSchedulingLink = (
  params: RouteGuestToOwnershipSchedulingLinkParams
) => {
  const { teamScheduling } = useApiClient()
  return useQuery(routeGuestToOwnershipSchedulingLinkQuery({ ...params, teamScheduling }))
}
